import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Flight } from "../../../../../store/slices/reservationSlice";

import { FlightItemCard } from "./flight-item-card";
import styles from "./flight-item-pair.module.scss";

interface FlightItemProps {
  outbound: Flight;
  inbound?: Flight;
}

export const FlightItemPair = ({ outbound, inbound }: FlightItemProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(styles.flightPair, {
        [styles.flightPair__double]: Boolean(inbound),
      })}>
      <div className={styles.flightPair_cardContainer}>
        <h4 className={styles.flightPair_title}>{t("outbound")}</h4>

        <FlightItemCard flight={outbound} />
      </div>

      {inbound && (
        <div className={styles.flightPair_cardContainer}>
          <h4 className={styles.flightPair_title}>{t("inbound")}</h4>

          <FlightItemCard flight={inbound} />
        </div>
      )}
    </div>
  );
};
